"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _preact = require("preact");

function getTheme(isControl, theme) {
  if (theme) {
    return theme;
  }

  return isControl ? 'control' : 'community';
}

var Modal = function Modal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      children = _ref.children,
      className = _ref.className,
      _ref$isControl = _ref.isControl,
      isControl = _ref$isControl === void 0 ? true : _ref$isControl,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'center' : _ref$placement,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? undefined : _ref$theme;
  if (!isOpen) return null;
  var modalTheme = getTheme(isControl, theme);
  return (0, _preact.h)("div", {
    className: className
  }, (0, _preact.h)("div", {
    className: "".concat(modalTheme, "-modal-overlay")
  }), (0, _preact.h)("section", {
    role: "dialog",
    tabIndex: 2,
    "aria-labelledby": "modal-header-title",
    "aria-describedby": "modal-description",
    className: "".concat(modalTheme, "-modal ").concat(modalTheme, "-modal-").concat(size, " ").concat(modalTheme, "-modal-").concat(placement)
  }, children));
};

exports.Modal = Modal;